export default __webpack_public_path__ + "static/kcas_video_testimonial-bc560e86efee380507f8e26b16d2b2aa.mp4";